// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/screens/billing.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/screens/eligibility.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/screens/platform.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/screens/dashboard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/screens/dashboard-mobile.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Hero_animated_frames__Pm8G1 {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.Hero_Hero__2aKvT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 80vh;
  border-radius: 30px;
  margin: 20px 0;
  background: linear-gradient(66deg, #ff9b50, #ffd050);
  background-size: 400% 400%;
  animation: Hero_animated_frames__Pm8G1 21s ease infinite;
}
.Hero_Hero__2aKvT .Hero_content__upM2- {
  width: 80%;
  padding: 50px;
}
.Hero_Hero__2aKvT .Hero_content__upM2- .Hero_labelHeader__Fue8i {
  color: #212121;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  font-size: 14px;
}
.Hero_Hero__2aKvT .Hero_content__upM2- .Hero_heroHeader__CN7T\\+ {
  margin-top: 10px;
  font-size: 3rem;
  color: #015d8e;
  margin-bottom: 20px;
}
.Hero_Hero__2aKvT .Hero_content__upM2- .Hero_heroSubtext__lZGcp {
  font-size: 1rem;
  line-height: 25px;
  color: #ffffff;
  margin-bottom: 30px;
}
.Hero_Hero__2aKvT .Hero_otherIllustration__J19ER {
  width: 100%;
  position: relative;
  padding: 50px 0;
}
.Hero_Hero__2aKvT .Hero_otherIllustration__J19ER .Hero_billingImage__3lych {
  height: 570px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid #e3ebf2;
  border-radius: 18px 0 0 18px;
}
.Hero_Hero__2aKvT .Hero_otherIllustration__J19ER .Hero_eligibilityImage__vjMKA {
  height: 570px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid #e3ebf2;
  border-radius: 18px 0 0 18px;
}
.Hero_Hero__2aKvT .Hero_otherIllustration__J19ER .Hero_platformImage__udW4l {
  height: 570px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid #e3ebf2;
  border-radius: 18px 0 0 18px;
}
.Hero_Hero__2aKvT .Hero_homeIllustration__8EGvD {
  padding: 50px 0 50px 260px;
  width: 100%;
  position: relative;
}
.Hero_Hero__2aKvT .Hero_homeIllustration__8EGvD .Hero_webImage__Gnakr {
  height: 570px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid #e3ebf2;
  border-radius: 18px 0 0 18px;
  box-shadow: 0 50px 100px -20px rgba(50, 50, 93, 0.25), 0 30px 60px -30px rgba(0, 0, 0, 0.3);
}
.Hero_Hero__2aKvT .Hero_homeIllustration__8EGvD .Hero_mobileImage__SWEfD {
  top: 120px;
  left: 0;
  height: 520px;
  width: 265px;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 15px;
  border: 1px solid #e3ebf2;
  box-shadow: 0 50px 100px -20px rgba(50, 50, 93, 0.25), 0 30px 60px -30px rgba(0, 0, 0, 0.3);
}
.Hero_Hero__2aKvT .Hero_illustration__hx2Tb {
  height: 80vh;
  width: 100%;
}
.Hero_Hero__2aKvT .Hero_illustration__hx2Tb img {
  border-radius: 0 30px 30px 0;
  height: 100%;
  width: 100%;
  height: 100%;
  display: block;
}
@media (max-width: 768px) {
  .Hero_Hero__2aKvT {
    flex-direction: column;
    text-align: center;
    max-height: unset;
    height: unset;
    margin: 10px 0;
  }
  .Hero_Hero__2aKvT .Hero_content__upM2- {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .Hero_Hero__2aKvT .Hero_content__upM2- .Hero_heroHeader__CN7T\\+ {
    font-size: 2.5rem;
  }
  .Hero_Hero__2aKvT .Hero_content__upM2- .Hero_heroSubtext__lZGcp {
    margin: 0 20px 30px 20px;
  }
  .Hero_Hero__2aKvT .Hero_illustration__hx2Tb {
    margin-top: 0;
    height: 40vh;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .Hero_Hero__2aKvT .Hero_illustration__hx2Tb img {
    width: calc(100% - 20px);
    border-radius: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAwBA;EACE;IACE,2BAAA;EADF;EAGA;IACE,6BAAA;EADF;EAGA;IACE,2BAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,oDAAA;EACA,0BAAA;EAIA,wDAAA;AAHF;AAKE;EACE,UAAA;EACA,aAAA;AAHJ;AAKI;EACE,cChDQ;EDiDR,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAHN;AAMI;EACE,gBAAA;EACA,eAAA;EACA,cC7DY;ED8DZ,mBAAA;AAJN;AAOI;EACE,eAAA;EACA,iBAAA;EACA,cClEQ;EDmER,mBAAA;AALN;AASE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AAPJ;AASI;EACE,aAAA;EACA,yDAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;AAPN;AAUI;EACE,aAAA;EACA,yDAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;AARN;AAWI;EACE,aAAA;EACA,yDAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;AATN;AAaE;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;AAXJ;AAaI;EACE,aAAA;EACA,yDAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,2FAAA;AAXN;AAeI;EACE,UAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,2FAAA;AAbN;AAkBE;EACE,YAAA;EACA,WAAA;AAhBJ;AAkBI;EACE,4BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhBN;AAoBE;EA5HF;IA6HI,sBAAA;IACA,kBAAA;IACA,iBAAA;IACA,aAAA;IACA,cAAA;EAjBF;EAmBE;IACE,eAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;EAjBJ;EAmBI;IACE,iBAAA;EAjBN;EAoBI;IACE,wBAAA;EAlBN;EAsBE;IACE,aAAA;IACA,YAAA;IACA,aAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EApBJ;EAsBI;IACE,wBAAA;IACA,mBAAA;EApBN;AACF","sourcesContent":["@import '../../variables';\n\n@-webkit-keyframes animated_frames {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@-moz-keyframes animated_frames {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@keyframes animated_frames {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.Hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 80vh;\n  border-radius: 30px;\n  margin: 20px 0;\n  background: linear-gradient(66deg, #ff9b50, #ffd050);\n  background-size: 400% 400%;\n\n  -webkit-animation: animated_frames 21s ease infinite;\n  -moz-animation: animated_frames 21s ease infinite;\n  animation: animated_frames 21s ease infinite;\n\n  .content {\n    width: 80%;\n    padding: 50px;\n\n    .labelHeader {\n      color: $black-color;\n      text-transform: uppercase;\n      font-weight: 600;\n      letter-spacing: 2px;\n      font-size: 14px;\n    }\n\n    .heroHeader {\n      margin-top: 10px;\n      font-size: 3rem;\n      color: $secondary-color;\n      margin-bottom: 20px;\n    }\n\n    .heroSubtext {\n      font-size: 1rem;\n      line-height: 25px;\n      color: $white-color;\n      margin-bottom: 30px;\n    }\n  }\n\n  .otherIllustration {\n    width: 100%;\n    position: relative;\n    padding: 50px 0;\n\n    .billingImage {\n      height: 570px;\n      background-image: url('../../assets//images/screens/billing.svg');\n      background-position: left;\n      background-size: cover;\n      background-repeat: no-repeat;\n      border: 1px solid $card-border-color;\n      border-radius: 18px 0 0 18px;\n    }\n\n    .eligibilityImage {\n      height: 570px;\n      background-image: url('../../assets//images/screens/eligibility.svg');\n      background-position: left;\n      background-size: cover;\n      background-repeat: no-repeat;\n      border: 1px solid $card-border-color;\n      border-radius: 18px 0 0 18px;\n    }\n\n    .platformImage {\n      height: 570px;\n      background-image: url('../../assets//images/screens/platform.svg');\n      background-position: left;\n      background-size: cover;\n      background-repeat: no-repeat;\n      border: 1px solid $card-border-color;\n      border-radius: 18px 0 0 18px;\n    }\n  }\n\n  .homeIllustration {\n    padding: 50px 0 50px 260px;\n    width: 100%;\n    position: relative;\n\n    .webImage {\n      height: 570px;\n      background-image: url('../../assets//images/screens/dashboard.svg');\n      background-position: left;\n      background-size: cover;\n      background-repeat: no-repeat;\n      border: 1px solid $card-border-color;\n      border-radius: 18px 0 0 18px;\n      box-shadow: 0 50px 100px -20px rgba(50, 50, 93, 0.25), 0 30px 60px -30px rgba(0, 0, 0, 0.3);\n      // inset 0 1px 1px 0 hsla(0, 0%, 100%, 0.1)\n    }\n\n    .mobileImage {\n      top: calc(50px + 70px);\n      left: 0;\n      height: 520px;\n      width: 265px;\n      position: absolute;\n      background-image: url('../../assets//images/screens/dashboard-mobile.svg');\n      background-position: top;\n      background-size: cover;\n      background-repeat: no-repeat;\n      border-radius: 15px;\n      border: 1px solid $card-border-color;\n      box-shadow: 0 50px 100px -20px rgba(50, 50, 93, 0.25), 0 30px 60px -30px rgba(0, 0, 0, 0.3);\n      // inset 0 -2px 6px 0 rgba(10, 37, 64, 0.35);\n    }\n  }\n\n  .illustration {\n    height: 80vh;\n    width: 100%;\n\n    img {\n      border-radius: 0 30px 30px 0;\n      height: 100%;\n      width: 100%;\n      height: 100%;\n      display: block;\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    text-align: center;\n    max-height: unset;\n    height: unset;\n    margin: 10px 0;\n\n    .content {\n      max-width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n\n      .heroHeader {\n        font-size: 2.5rem;\n      }\n\n      .heroSubtext {\n        margin: 0 20px 30px 20px;\n      }\n    }\n\n    .illustration {\n      margin-top: 0;\n      height: 40vh;\n      padding: 10px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        width: calc(100% - 20px);\n        border-radius: 20px;\n      }\n    }\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Hero": `Hero_Hero__2aKvT`,
	"animated_frames": `Hero_animated_frames__Pm8G1`,
	"content": `Hero_content__upM2-`,
	"labelHeader": `Hero_labelHeader__Fue8i`,
	"heroHeader": `Hero_heroHeader__CN7T+`,
	"heroSubtext": `Hero_heroSubtext__lZGcp`,
	"otherIllustration": `Hero_otherIllustration__J19ER`,
	"billingImage": `Hero_billingImage__3lych`,
	"eligibilityImage": `Hero_eligibilityImage__vjMKA`,
	"platformImage": `Hero_platformImage__udW4l`,
	"homeIllustration": `Hero_homeIllustration__8EGvD`,
	"webImage": `Hero_webImage__Gnakr`,
	"mobileImage": `Hero_mobileImage__SWEfD`,
	"illustration": `Hero_illustration__hx2Tb`
};
export default ___CSS_LOADER_EXPORT___;
